import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 秋霞电影`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2">
          {rank ? (
            <span className="flex h-7 min-w-7 items-center justify-center rounded-md bg-accent-500 px-2 text-sm font-bold text-background-50">
              {rank}
            </span>
          ) : (
            <span className="rounded-md bg-primary-950/80 px-2 py-1 text-xs text-background-100">{movie.region}</span>
          )}
          <span className="flex items-center gap-1 rounded-md bg-background-50/95 px-2 py-1 text-xs font-semibold text-accent-700">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill"></i></span>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/90 to-transparent px-2 pb-2 pt-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">{movie.tagline}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-600">导演：{movie.director}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{movie.year} · {movie.genres[0]}</span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-fire-line"></i></span>
            {movie.heat}
          </span>
        </div>
      </div>
    </Link>
  );
}